<template>
  <div>
    <b-modal
      v-model="modalShowRespuesta"
      size="lg"
      :title="titleModalRespuesta"
      ok-title="Asignar"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      no-close-on-esc
      :busy="isBusyRespuesta"
      :hide-footer="true"
      @ok="okMdlRespuesta"
    >
      <b-overlay
        :show="isBusyRespuesta"
        rounded="sm"
      >
        <respuesta-ver
          ref="refRespuestaForm"
          :is-busy-respuesta.sync="isBusyRespuesta"
          :modal-show.sync="modalShowRespuesta"
          :type-action="typeAction"
          :data-respuesta="dataRespuesta"
          @refetch-data="refetchDataRespuesta"
          @error-data="showError"
        />
      </b-overlay>
    </b-modal>
    <b-modal
      v-model="modalShowMap"
      size="lg"
      :title="titleModalMap"
      ok-title="Asignar"
      cancel-variant="outline-secondary"
      no-close-on-backdrop
      no-close-on-esc
      :busy="isBusyMap"
      :hide-footer="true"
      @ok="okMdlMap"
    >
      <b-overlay
        :show="isBusyMap"
        rounded="sm"
      >
        <google-map
          ref="refGoogleMap1"
          :is-busy-map.sync="isBusyMap"
          :modal-show.sync="modalShowMap"
          :type-action="typeAction"
          :data-map="dataMap"
          @refetch-data="refetchDataMap"
          @error-data="showError"
        />
      </b-overlay>
    </b-modal>
    <!-- Navbar AppNavbarVerticalLayout -->
    <b-navbar
      class="header-navbar navbar navbar-shadow align-items-center"
      style="z-index: 2;"
    >
      <div class="navbar-container d-flex content align-items-center">
        <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
          <!-- Bookmarks Container -->
          <!-- <bookmarks /> -->
          <!-- <span><h3>Reportes y Visor de Mapas de Gs Encuesta</h3></span> -->
          <b-form-group
            label="Dependencia"
            label-for="proyecto"
            style="margin-right: 10px !important"
          >
            <b-form-select
              v-model="selectProyecto"
              type="select"
              class="custom-select"
              @change="getSelectedProyecto"
            >
              <option value="">
                SELECCIONE::
              </option>
              <option
                v-for="proy in optionProyecto"
                :key="proy.idProyecto"
                :value="proy.idProyecto"
              >
                {{ proy.nombre }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group
            label="Encuesta"
            label-for="Encuesta"
            @change="getSelectedEncuesta"
          >
            <b-form-select
              v-model="selectEncuesta"
              type="select"
              class="custom-select"
            >
              <option value="">
                TODOS::
              </option>
              <option
                v-for="quiz in optionEncuesta"
                :key="quiz.idEncuesta"
                :value="quiz.idEncuesta"
              >
                {{ quiz.titulo }}
              </option>
            </b-form-select>
          </b-form-group>
          <span
            style="padding: 5px;"
          >
            <feather-icon
              v-b-tooltip.hover.bottom="infoEncuesta"
              icon="InfoIcon"
            />
          </span>
          <span
            style="padding: 5px;"
          >
            <b-badge
              v-if="metaEncuesta != 0"
              pill
              variant="light-primary"
            >
              Meta: {{ metaEncuesta }}
            </b-badge>
          </span>
          <span
            v-show="excelFicha"
            style="padding: 5px;"
          >
            <download-excel
              v-show="excelFicha"
              class="btn btn-default"
              :fields="json_fields"
              :fetch="()=>{return getFicha()}"
              worksheet="Ficha"
              name="reporte_ficha.xls"
            >
              <b-img
                :src="imgExcel"
                width="24"
                data-toggle="tooltip"
                data-placement="top"
                title="Descargar Fichas"
              />
            </download-excel>
          </span>
          <!-- style="margin-left: -20px;" -->
          <!-- <span
            v-show="excelFicha"
          >
            <a
              @click="generarConsolidado"
            >
              <b-img
                :src="imgPdfCons"
                width="24"
                data-toggle="tooltip"
                data-placement="top"
                title="Descargar Consolidado"
              />
            </a>
          </span -->
        </div>
        <b-navbar-nav
          style="width:30%"
        >
          <b-form-datepicker
            id="fechaInicio"
            v-model="fechaInicio"
            class="mb-1"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            locale="es"
            placeholder="Fecha Inicio"
            style="margin-right:6px !important"
          />
          <b-form-datepicker
            id="fechaFinal"
            v-model="fechaFinal"
            class="mb-1"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            locale="es"
            placeholder="Fecha Final"
          />
        </b-navbar-nav>
      </div>
    </b-navbar>
    <br>
    <!--/ Navbar -->
    <section
      id="dashboard-ecommerce"
    >
      <b-row
        class="match-height"
      >
        <b-col
          sm="12"
        >
          <b-table
            ref="refUserListTable"
            class="position-relative"
            :items="itemsFicha"
            responsive
            :fields="fieldsFicha"
            primary-key="id"
            :sort-by.sync="sortByFicha"
            show-empty
            small
            empty-text="No se encontraron registros"
            :busy="isBusy"
          >
            <template #table-busy>
              <div class="text-center text-primary my-2">
                <b-spinner
                  variant="primary"
                  class="align-middle"
                />
                <strong class="ml-1">Cargando...</strong>
              </div>
            </template>
            <template #cell(time)="data1">
              <b-media vertical-align="center">
                <b-link
                  class="font-weight-bold d-block text-nowrap"
                >
                  {{ parseTime(data1.item.fechaInicio, data1.item.fechaFin) }}
                </b-link>
                <small class="text-muted">Fecha Inicio: {{ parseDate(data1.item.fechaInicio) }}. Fecha Final: {{ parseDate(data1.item.fechaFin) }} Fecha Envio: {{ parseDate(data1.item.fechaEnvio) }}</small>
              </b-media>
            </template>
            <template #cell(longitud)="data1">
              <b-media vertical-align="center">
                <small class="text-muted">
                  <a
                    @click="openMap(data1.item)"
                  >
                    <feather-icon
                      icon="MapIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                    Latitud: {{ data1.item.latitud }}. Longitud: {{ data1.item.longitud }}
                  </a>
                </small>
              </b-media>
            </template>
            <template #cell(encuestado)="data1">
              <b-media vertical-align="center">
                <b-link
                  class="font-weight-bold d-block text-nowrap"
                >
                  {{ data1.item.encuestado.documento }}
                </b-link>
                <small class="text-muted">{{ data1.item.encuestado.nombre }} {{ data1.item.encuestado.apellidoPaterno }} {{ data1.item.encuestado.apellidoMaterno }}</small>
              </b-media>
            </template>
            <template #cell(validadoReniec)="data1">
              <b-badge
                v-if="data1.item.encuestado.validadoReniec == true"
                pill
                variant="light-success"
                class="text-capitalize"
              >
                SI
              </b-badge>

              <b-badge
                v-if="data1.item.encuestado.validadoReniec == false"
                pill
                variant="light-danger"
                class="text-capitalize"
              >
                NO
              </b-badge>
            </template>
            <template #cell(observacion)="data1">
              <b-media vertical-align="center">
                <small class="text-muted">{{ data1.item.observacion }}</small>
              </b-media>
            </template>
            <template #cell(fechaRetomo)="data1">
              <b-media vertical-align="center">
                <b-link
                  class="font-weight-bold d-block text-nowrap"
                >
                  {{ data1.item.fechaRetomo }}
                </b-link>
                <small class="text-muted">Longitud: {{ data1.item.longitudRetomo }}  Latitud: {{ data1.item.longitudRetomo }}</small>
              </b-media>
            </template>
            <!-- Column: Actions -->
            <template #cell(op)="data1">
              <b-dropdown
                variant="link"
                no-caret
                :right="$store.state.appConfig.isRTL"
              >
                <template #button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="align-middle text-body"
                  />
                </template>
                <b-dropdown-item @click="getRespuesta(data1)">
                  <feather-icon icon="EditIcon" />
                  <span class="align-middle ml-50">Ver Respuestas</span>
                </b-dropdown-item>
              </b-dropdown>
            </template>
          </b-table>
        </b-col>
      </b-row>
    </section>
  </div>
</template>

<script>
import useAppConfig from '@core/app-config/useAppConfig'
import { BRow, BCol, BNavbar, BNavbarNav, BFormDatepicker, BBadge, BFormSelect, BFormGroup, VBTooltip, BImg, BTable,
  BMedia, BLink, BDropdown, BDropdownItem, BSpinner, BOverlay } from 'bootstrap-vue'
import moment from 'moment'
import axios from 'axios'
import store from '@/store'
import { _ } from 'vue-underscore'
import imgExcel1 from '../../../assets/images/encuesta/excel.png'
import imgExcel2 from '../../../assets/images/encuesta/pdf-icon.png'
import RespuestaVer from './RespuestaVer.vue'
import GoogleMap from './GoogleMap.vue'

export default {
  components: {
    // AppCustomizer,
    BRow,
    BCol,
    BNavbar,
    BNavbarNav,
    BFormDatepicker,
    BFormSelect,
    BImg,
    BFormGroup,
    BBadge,
    BTable,
    BMedia,
    BLink,
    BDropdown,
    BDropdownItem,
    BSpinner,
    BOverlay,
    RespuestaVer,
    GoogleMap,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  data() {
    return {
      itemsFicha: [],
      sortByFicha: null,
      isBusy: false,
      fieldsFicha: [
        { key: 'index', label: '#' },
        { key: 'time', label: 'Ejecución' },
        { key: 'longitud', label: 'Coordenadas' },
        { key: 'encuestado', label: 'Encuestado' },
        { key: 'validadoReniec', label: 'validadoReniec' },
        { key: 'observacion', label: 'observacion' },
        { key: 'op' },
        // { key: 'fechaRetomo', label: 'retomo' },
      ],
      data: {},
      formTypeUbigeo: '',
      optionProyecto: [],
      optionEncuesta: [],
      userData: JSON.parse(localStorage.getItem('userData')),
      userProfile: JSON.parse(localStorage.getItem('userProfile')),
      meta: 0,
      totalFicha: 0,
      selectProyecto: '',
      selectEncuesta: '',
      infoEncuesta: '',
      excelFicha: false,
      selectUsuario: '',
      imgExcel: imgExcel1,
      imgPdfCons: imgExcel2,
      metaEncuesta: 0,
      fechaInicio: '',
      fechaFinal: '',
      dataEncuestador: [],
      isAddNewSidebarActive: false,
      modalShowRespuesta: false,
      isBusyRespuesta: false,
      titleModalRespuesta: 'Resultado de la Encuesta',
      dataRespuesta: {},
      modalShowMap: false,
      isBusyMap: false,
      titleModalMap: 'Visor de Mapas',
      dataMap: {},
      typeAction: 'ver',
      json_fields: {
        idFicha: 'idFicha',
        institucion: 'institucion',
        proyecto: 'proyecto',
        EncuestaTitulo: 'encuestaTitulo',
        encuestadoNombre: 'encuestadoNombre',
        encuestadoDocumento: 'encuestadoDocumento',
        latitud: 'latitud',
        longitud: 'longitud',
        fechaInicio: 'fechaInicio',
        fechaFinal: 'fechaFinal',
        // tiempoTranscurrido: 'TiempoTranscurrido',
        fechaEnvio: 'fechaEnvio',
        latitudRetomo: 'latitudRetomo',
        longitudRetomo: 'longitudRetomo',
        fechaRetomo: 'fechaRetomo',
        observacion: 'observacion',
      },
    }
  },
  watch: {
    selectProyecto: {
      async handler() {
        await this.generateReportMap()
      },
    },
    selectEncuesta: {
      async handler() {
        await this.generateReportMap()
      },
    },
    fechaInicio: {
      async handler() {
        await this.generateReportMap()
      },
    },
    fechaFinal: {
      async handler() {
        await this.generateReportMap()
      },
    },
  },
  async mounted() {
    this.fechaInicio = moment().format('YYYY-MM-DD')
    this.fechaFinal = moment().format('YYYY-MM-DD')
    await this.loadProyecto()
    await this.generateReportMap()
  },
  setup() {
    const {
      navbarTypeClass,
      navbarBackgroundColor,
    } = useAppConfig()

    return {
      navbarTypeClass,
      navbarBackgroundColor,
    }
  },
  methods: {
    async generarConsolidado() {
      await store
        .dispatch('gsencuesta/TABLERO_INDICADOR_CONSOLIDADO_FICHA_PDF',
          {
            idEncuesta: this.selectEncuesta,
            fechaInicio: this.fechaInicio,
            fechaFinal: this.fechaFinal,
            selectUsuario: this.userData.id,
          })
        .then(res => {
          const a = document.createElement('a')
          a.target = '_blank'
          a.href = res
          a.download = 'descargar.pdf'
          a.click()
        })
        .catch(error => {
          console.log(error)
        })
    },
    okMdlRespuesta(ev) {
      ev.preventDefault()
    },
    okMdlMap(ev) {
      ev.preventDefault()
    },
    openMap(data) {
      this.loadState()
      this.titleModalMap = 'Visor de Mapas'
      const mut = {
        oper: 'show',
        datMap: data,
      }
      this.$store.commit('gsencuesta/OPERACION_INDICADOR_MAP', mut)
      this.modalShowMap = true

      // his.$refs.refGoogleMap1.generateMapa(data)
      // this.dataMap = data
    },
    refetchDataRespuesta(response) {
      console.log(response)
    },
    refetchDataMap(response) {
      console.log(response)
    },
    async getFicha() { // https://dev.regionsanmartin.gob.pe
      // const response = await axios.get(`http://localhost:8081/gsencuesta/api/v1/encuesta/findFichaParsed?idEncuesta=${this.selectEncuesta}&fechaInicio=${this.fechaInicio}&fechaFinal=${this.fechaFinal}&idUsuario=${this.selectUsuario}`)
      const response = await axios.get(`https://apimesa.regionsanmartin.gob.pe/gsencuesta/api/v1/encuesta/findFichaParsed?idEncuesta=${this.selectEncuesta}&fechaInicio=${this.fechaInicio}&fechaFinal=${this.fechaFinal}&idUsuario=${this.selectUsuario}`)
      return response.data
    },
    async generateReportMap() {
      // this.$forceUpdate()
      this.metaEncuesta = 0
      if (this.selectEncuesta !== '') {
        this.isBusy = true
        await store
          .dispatch('gsencuesta/ENCUESTA_FIND_FICHA', {
            idEncuesta: this.selectEncuesta,
            idProyecto: this.selectProyecto,
            fechaInicio: this.fechaInicio,
            fechaFinal: this.fechaFinal,
            idUsuario: (this.userProfile.idPerfil === 4) ? this.userData.id : '',
          })
          .then(response => {
            if (response !== undefined) {
              this.itemsFicha = response
              this.totalFicha = response.length
              this.isBusy = false
              this.excelFicha = true
              // this.$refs.refGoogleMaps.generateMapa(this.dataMap)
            }
          })
          .catch(error => {
            this.isBusy = false
            this.$bvToast.toast(error, {
              title: 'He ocurrido un error',
              variant: 'danger',
              solid: true,
            })
          })
        const filterQuiz = _.findWhere(this.optionEncuesta, { idEncuesta: this.selectEncuesta })
        this.infoEncuesta = (filterQuiz === undefined) ? '' : filterQuiz.descripcion
        // console.log(filterQuiz)
        this.meta = (filterQuiz === undefined) ? '' : filterQuiz.meta
        this.metaEncuesta = this.meta
      }
    },
    getSelectedProyecto(option) {
      this.selectEncuesta = ''
      this.optionEncuesta = []
      this.excelFicha = false
      if (option !== '') {
        this.loadEncuesta(option)
      }
    },
    loadState() {
      const mut0 = {
        oper: 'list',
        datMap: {},
      }
      this.$store.commit('gsencuesta/OPERACION_INDICADOR_MAP', mut0)
    },
    getSelectedEncuesta() {
      this.selectEncuesta = ''
      this.optionEncuesta = []
      this.excelFicha = false
    },
    async loadProyecto() {
      await store
        .dispatch('gsencuesta/PROYECTO_FIND_ALL', { // PROYECTO_FIND_ALL
          limit: -1,
          query: '',
          page: -1,
          sortBy: 'idProyecto%7CDESC',
          // idInstitucion: -1,
          idInstitucion: this.userData.idInstitucion,
        })
        .then(response => {
          if (response !== undefined && response.length > 0) {
            this.optionProyecto = response
            this.selectProyecto = response[0].idProyecto
            this.getSelectedProyecto(this.selectProyecto)
          }
        })
        .catch(error => {
          const message = (error.response.status === 401) ? 'No Autorizado' : error.response.data.errorMessage
          this.$bvToast.toast(message, {
            title: 'He ocurrido un error',
            variant: 'danger',
            solid: true,
          })
        })
    },
    async loadEncuesta(idProyecto) {
      this.optionEncuesta = []
      await store
        .dispatch('gsencuesta/ENCUESTA_FIND_BY_PROYECTO', {
          idProyecto,
        })
        .then(response => {
          if (response !== undefined && response.length > 0) {
            this.optionEncuesta = response
            // this.infoEncuesta = response[0].descripcion
          }
        })
        .catch(error => {
          this.$bvToast.toast(error, {
            title: 'He ocurrido un error',
            variant: 'danger',
            solid: true,
          })
        })
    },
    getRespuesta(data) {
      store
        .dispatch('gsencuesta/TABLERO_INDICADOR_PREGUNTA_RESPUESTA', {
          idFicha: data.item.idFicha,
        })
        .then(response => {
          if (response !== undefined) {
            this.titleModalRespuesta = 'Resultado de Encuesta'
            this.modalShowRespuesta = true
            this.dataRespuesta = response.data
          }
        })
        .catch(() => {
          // notify(error, 'He ocurrido un error', 'danger')
        })
    },
    showError(error) {
      let errorMessage = 'Intentelo en otro momento.'
      if (error.response) {
        errorMessage = error.response.data.errorMessage
      }
      this.$bvToast.toast(errorMessage, {
        title: 'Ha ocurrido un error',
        variant: 'danger',
        solid: true,
      })
    },
    parseDate(date) {
      const date1 = (!date || date === null) ? '' : moment(date).locale('es').format('YYYY-MM-DD')
      return date1
    },
    parseTime(fi, ff) {
      let time1 = '0 min'
      const a = moment(fi)
      const b = moment(ff)
      const m = b.diff(a, 'minutes')
      const textMin = (m > 1) ? 'Minutos' : 'Minuto'
      time1 = `${m} ${textMin}`
      return time1
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/chart-apex.scss';
</style>
